const Customer = (target) => {
  const customerBtn = target.querySelector(".customer__dropdown-button");
  const customerDropdown = target.querySelector(".customer__dropdown");

  const method = {
    init: () => {
      customerBtn.addEventListener("click", method.onClick);
      document.addEventListener("click", method.isClickInside);
    },
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (method.isOpen()) {
        method.doClose();
      } else {
        method.doOpen();
      }
    },
    isOpen: () => customerDropdown.classList.contains("customer__dropdown--open"),
    isClickInside: (e) => {
      const isClickInside = customerDropdown && customerDropdown.contains(e.target);

      if (!isClickInside && method.isOpen()) {
        method.doClose();
      }
    },
    doOpen: () => {
      customerDropdown.classList.add("customer__dropdown--open");
    },
    doClose: () => {
      customerDropdown.classList.remove("customer__dropdown--open");
    },
  };

  if (customerBtn) {
    method.init();
  }
};

export default Customer;
